<div class="scheduler__calendar-header">
    <div class="row">
        <p class="col-8 m-0 scheduler__calendar-month-name">
            {{ calendarViewType | calendarDate:(calendarView + 'ViewTitle'):'en' }}</p>
        <div class="text-right col-4 m-0 scheduler__calendar-flags">
            <i (click)="toggleView(flagIsActive)" [class.active]="flagIsActive"
                class="scheduler-fa fa-flag has-notification"></i>
            <span class="scheduler-flags__devider"></span>
            <i (click)="toggleView(agendaIsActive)" [class.active]="agendaIsActive"
                class="scheduler-fa fa-list-alt"></i>
        </div>
    </div>
</div>